import { useState } from 'react';
import styles from './ExtendedSelect.module.css';
import clsx from 'clsx';

type Option = {
  value: string;
  name: string;
};

type ExtendedSelectProps = {
  propStyle: string;
  label?: string;
  options: Option[];
  handleChangeOption: (item: string) => void;
  selectedOption: string;
};

const ExtendedSelect = (props: ExtendedSelectProps) => {
  const { label, options } = props;
  const [isOpen, setIsOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState<Option>(
    options.find(element => props.selectedOption === element.value)
  );

  const handleOpen = () => {
    setIsOpen(state => !state);
  };

  const handleSelect = (item: Option) => {
    setSelectedOption(item);
    setIsOpen(false);
    props.handleChangeOption(item.value);
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.container}>
        <button className={isOpen ? styles.expanded : ''} onClick={handleOpen}>
          <span className={styles.label}>{label}</span>
          <span className={styles.value}>{selectedOption.name}</span>
          <span className={clsx(styles.icon, !isOpen && styles.opened)}>
            <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 384 512'>
              <path d='M352 352c-8.188 0-16.38-3.125-22.62-9.375L192 205.3l-137.4 137.4c-12.5 12.5-32.75 12.5-45.25 0s-12.5-32.75 0-45.25l160-160c12.5-12.5 32.75-12.5 45.25 0l160 160c12.5 12.5 12.5 32.75 0 45.25C368.4 348.9 360.2 352 352 352z' />
            </svg>
          </span>
        </button>
        <ul className={clsx(styles.options, isOpen && styles.show)}>
          {options.map(item => (
            <li key={item.value} onClick={() => handleSelect(item)}>
              {item.name}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default ExtendedSelect;
